import type { NextPage } from 'next'
import { ReferenceCustomers } from '@/client/modules/ReferenceCustomers'
import { ReferenceCustomersProps } from '@/client/modules/ReferenceCustomers/types'
import { getCMSContent } from '@/client/utils'

const ReferenceCustomersPage: NextPage<ReferenceCustomersProps> = (data) => <ReferenceCustomers {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'REFERENCE_CUSTOMERS')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default ReferenceCustomersPage
